<template>
  <div
    v-if="!computedHide"
    class="input-element"
    :class="[(name)?`input-element--${name}`:'', {'disabled': disabled}, `input-element--${type}`]"
  >
    <h4
      v-if="title"
      class="g-title g-title--subtitle"
    >
      {{ title }}
    </h4>
    <div class="input-element-wrapper">
      <div
        class="input-element__name g-btn g-btn--semi-rounded"
        @click="inputFocus"
      >
        <span
          v-if="prefix"
          class="input-element__name__prefix"
        >
          {{ prefix }}
        </span>

        <input
          ref="focus"
          v-model="modifiedText"
          class="input-element__name__input"
          :type="type"
          :min="min"
          :max="max"
          :step="step"
          :maxlength="maxLength"
          :placeholder="placeholder"
          :disabled="disabled"
          @blur="blur"
          @keyup="userTyping"
        >
        <font-awesome-icon
          v-if="!(disabled || type === 'number')"
          :icon="['fas', 'edit']"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

export default {
  name: 'InputElement',
  components: {
    'font-awesome-icon': FontAwesomeIcon
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    text: {
      type: [String, Number, null, undefined],
      default: undefined,
    },
    prefix: {
      type: String,
      default: ''
    },
    hide: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '',
    },
    emitFunctionNamed: { // Legacy @TODO: refactor removal
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    maxLength: {
      type: Number,
      default: 120,
    },
    min: {
      type: [Number, String],
      default: "",
    },
    max: {
      type: [Number, String],
      default: "",
    },
    step: {
      type: [Number, String],
      default: "",
    },
    type: {
      type: String,
      default: "text",
    }
  },
  data() {
    return {
      modifiedText: null,
      lastAcceptedValue: null
    }
  },
  computed: {
    computedHide() {
      return this.hide || this.text === undefined// return this.text === undefined || this.text === null || this.hide === true
    }
  },
  watch: {
    text: {
      immediate: true,
      handler(newValue) {
        this.modifiedText = this.lastAcceptedValue = this.stripControlCodes(newValue)
      }
    }
  },
  methods: {
    stripControlCodes: (test) =>
      test !== null && test !== undefined
      ? (test.toString().trim()).split('').filter(x => x.charCodeAt(0) > 31).join('')
      : ''
    ,
    inputFocus() {
      this.$refs.focus.focus()
    },
    returnText() {
      this.lastAcceptedValue = this.modifiedText
      this.$emit(this.emitFunctionNamed || 'change', this.modifiedText)
    },
    validate(input) {
      let tempVal = input.value

      if(tempVal === this.lastAcceptedValue) return false

      tempVal = this.stripControlCodes(tempVal.trim())

      if(this.type === 'number') {
        if(this.min !== '' && tempVal < this.min) tempVal = this.min.toString()
        if(this.max !== '' && tempVal > this.max) tempVal = this.max.toString()
      }

      input.value = tempVal

      if(input.checkValidity()) {
        this.modifiedText = tempVal
        return true
      } else {
        console.log('not valid', tempVal, input.checkValidity())
      }
    },
    userTyping(e) {
      if(e.keyCode === 13)
        this.validate(e.currentTarget) ? this.returnText() : false
    },
    blur(e) {
      this.validate(e.currentTarget)
      ? this.returnText()
      : false
    }
  }
}
</script>

<style lang="scss">
.input-element {
  svg {
    position: absolute;
    right: 5px;
  }

  &--center {
    margin: 0 auto;
    text-align: center;
  }

  &--number {
    input {
      text-align: right;
    }
  }

  .input-element-wrapper {
    box-sizing: border-box;
    display: block;
    padding: 10px 0px;
    display: flex;
    align-items: stretch;
    position: relative;
  }

  .runtime-error {
    position: absolute;
    bottom: calc(100% + 8px);
    left: 0;
    background-color: rgba($color-red-error, 0.7);
    color: $color-white;
    padding: 3px;
    font-size: 12px;
    line-height: 14px;
    border-radius: $application-base-border-radius;

    @include arrow('bottom', rgba($color-red-error, 0.7), 6px);
  }

  &__name {
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    margin: 2px;
    width: 100%;

    .disabled & {
      background: $color-grey-light;
    }

    > * {
      flex: 0 1 auto;
    }

    &__prefix {
      padding-left: 5px;
      margin-right: 10px;
    }

    &__input, &__icon {
      border: 0;
      background: transparent;
      color: $color-grey-darker;
    }
    &__icon {
      padding: 0;
    }
    &__input {
      box-sizing: border-box;
      display: inline-block;
      width: calc(100% - 25px);
      height: 100%;

      &:invalid {
        border: $color-red-error;
      }

      .input-element--number & {
        width: 100%;
      }

      .input-element--center & {
        width: 100%;
        text-align: center;
      }
    }
  }
}
</style>
